import axios, { AxiosRequestConfig, AxiosResponse } from "axios";

// Define a custom error class to hold the response data and status
class ApiError extends Error {
  response: AxiosResponse | undefined;

  constructor(message: string, response: AxiosResponse | undefined) {
    super(message);
    this.response = response;
  }
}

export const apiCall = async <T>(
  url: string,
  method: "GET" | "POST" | "PUT" | "DELETE" = "GET",
  data: any = null,
  headers: Record<string, string> = {
    Authorization: `bearer ${localStorage?.getItem("accessToken")}`,
    "Content-Type": "application/json"
  }
): Promise<T> => {
  try {
    const config: AxiosRequestConfig = {
      url,
      method,
      headers: {
        ...headers
        // Add any default headers you want to include in every request
      },
      data
    };

    const response = await axios(config);

    // If the response is not in the range of 2xx, it will throw an error
    if (response.status < 200 || response.status >= 300) {
      // Here you can add your custom error handling
      throw new ApiError(response.statusText, response);
    }

    return response.data as T;
  } catch (error: any) {
    return error?.response;
  }
};
